import React from 'react';
import '../../styles/card.css';

const Card = ({
  children,
  title,
  subtitle,
  headerAction,
  footer,
  padding = true,
  bordered = true,
  hoverable = false,
  className = '',
  ...props
}) => {
  const cardClasses = [
    'card',
    bordered ? 'card-bordered' : '',
    hoverable ? 'card-hoverable' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={cardClasses} {...props}>
      {(title || subtitle || headerAction) && (
        <div className="card-header">
          <div className="card-title-wrapper">
            {title && <h3 className="card-title">{title}</h3>}
            {subtitle && <p className="card-subtitle">{subtitle}</p>}
          </div>
          {headerAction && <div className="card-header-action">{headerAction}</div>}
        </div>
      )}
      
      <div className={`card-body ${padding ? 'card-body-padded' : ''}`}>
        {children}
      </div>
      
      {footer && <div className="card-footer">{footer}</div>}
    </div>
  );
};

export default Card;